import React from 'react';

interface PageLayoutProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  headerClassName?: string;
}

/**
 * Standard page layout component that provides consistent structure across all pages.
 * 
 * @param title - Main page title
 * @param subtitle - Page description
 * @param children - Page content
 * @param actions - Optional action buttons (usually in top right)
 * @param className - Additional classes for the content container
 * @param headerClassName - Additional classes for the header section
 */
export const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  subtitle,
  children,
  actions,
  className = '',
  headerClassName = ''
}) => {
  return (
    <div className="min-h-screen bg-white lg:ml-16 pt-4 lg:pt-0">
      <div className="w-[95%] mx-auto">
        <div className="py-4">
          <div className={`flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8 ${headerClassName}`}>
            <div className="flex-1 min-w-0">
              <h1 className="text-3xl font-bold text-gray-900 font-title mb-2">
                {title}
              </h1>
              <p className="mt-1 text-gray-500 font-body">
                {subtitle}
              </p>
            </div>
            {actions && (
              <div className="flex items-center gap-3">
                {actions}
              </div>
            )}
          </div>
          <div className={className}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}; 